import type { ReactElement, VoidFunctionComponent } from 'react';

import type { Jira } from '../../../../../shared/model-typings';

import styles from './ProjectIssueTrackerSettings.module.less';

type SiteConfigurationSectionItemProps = {
  label: string;
  contents: string | string[];
};

const SiteConfigurationSectionItemNone = (<span className={styles.siteConfigListItemNone}>None</span>);

//  One of the list items in the SiteFields section
const SiteConfigurationSectionItem: VoidFunctionComponent<SiteConfigurationSectionItemProps> = ({
  label,
  contents,
}) => {
  //  Checks if the contents are empty, and if not, determines if we need to join the array to a string.
  const contentsText: string | ReactElement = contents.length > 0 // eslint-disable-line no-nested-ternary
    ? Array.isArray(contents)
      ? contents.join(', ')
      : contents
    : SiteConfigurationSectionItemNone;
  return (
    <li className={styles.siteConfigListItem}>
      <span className={styles.siteConfigListItemLabel}>{label}</span>
      {': '}
      {contentsText}
    </li>
  );
};

type Props = {
  jira: Partial<Jira>;
};

/**
 * ProjectIssueTrackerSettingsSiteConfiguration
 */
const ProjectIssueTrackerSettingsSiteConfiguration: VoidFunctionComponent<Props> = ({ jira }) => {
  const {
    name,
    jiraProjectIds = [],
    issueTypes = [],
    labels = [],
    customFields = {},
  } = jira;
  return (
    <div className={styles.siteConfig}>
      <h4 className={styles.siteConfigHeading}>
        Site configuration for {name || 'this Jira site'}
      </h4>
      <ul className={styles.siteConfigList}>
        {jiraProjectIds && <SiteConfigurationSectionItem label="Project ID(s)" contents={jiraProjectIds} />}
        {issueTypes && <SiteConfigurationSectionItem label="Issue Types" contents={issueTypes} />}
        {labels && <SiteConfigurationSectionItem label="Labels" contents={labels} />}
      </ul>
      {customFields && (
        <div className="margin-bottom-sm">
          <h4 className={styles.siteConfigHeading}>
            Custom Fields
          </h4>
          <ul className={styles.siteConfigList}>
            {Object.values(customFields).map(customField => (
              <SiteConfigurationSectionItem
                label={customField.displayName}
                contents={`(${customField.fieldId}) ${customField.defaultValue ? customField.defaultValue : ''}`}
              />
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default ProjectIssueTrackerSettingsSiteConfiguration;
